import { useContext, useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { EmailMP, IdMP, PasswordMP, PhoneMP } from "../../../Icons";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./style.css";
import api from "../../../../services/api";
import { CadastroContext } from "../../../../contexts/CadastroContext";
import AlertMessage from "../../../Alert";
import { Load } from "../../../Load";

const AsoValidarInfo = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [isDisabled, setIsDisabled] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [userId, setUserId]: any = useState(null);
	console.log("🚀 ~ AsoValidarInfo ~ userId:", userId);
	const [alert, setAlert] = useState({
		show: false,
		message: "",
		variant: "success",
	});
	const { cadastro, handleCadastroChange, handleCadastroClear } =
		useContext(CadastroContext);
	const { idConsulta, dbName } = useParams();

	const redirectMap: any = {
		email: `/aso/registro/validar-email/${dbName}`,
		id: `/aso/registro/validar-nome/${dbName}`,
		telefone: `/aso/registro/validar-telefone/${dbName}`,
		password: `/aso/registro/validar-senha/${dbName}`,
	};

	if (location.pathname === `/aso/registro/validar-info-aso/${dbName}`) {
		redirectMap.email = `/aso/registro/validar-email-aso/${dbName}`;
		redirectMap.id = `/aso/registro/validar-nome-aso/${dbName}`;
		redirectMap.telefone = `/aso/registro/validar-telefone-aso/${dbName}`;
		redirectMap.password = `/aso/registro/validar-senha-aso/${dbName}`;
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		const verificarDocumentoAssinadoPorIdConsulta = async () => {
			const response = await api.get(
				`verificar-documento-assinado/${cadastro.idConsulta}/${dbName}`,
			);
			return response.data;
		};

		const initialize = async () => {
			try {
				if (idConsulta) {
					setIsLoading(true);
					cadastro.primeiraVez = true;
					cadastro.idConsulta = idConsulta;
					handleCadastroChange(cadastro);
					if (await verificarDocumentoAssinadoPorIdConsulta())
						return navigate("/aso/registro/documento-assinado");
					if (!cadastro.primeiraVez)
						return navigate(
							`/aso/registro/reconhecimento-facial/${cadastro.idConsulta}`,
						);
					setIsLoading(false);
				}

				if (
					cadastro.emailValidado &&
					cadastro.frenteDocumentoValidado &&
					cadastro.versoDocumentoValidado &&
					cadastro.passwordValidada
				) {
					setIsDisabled(false);
				}
			} catch (error) {
				if (error instanceof Error) {
					setIsLoading(false);
					setAlert({ show: true, message: error.message, variant: "danger" });
				}
			}
		};

		void initialize();
	}, []);

	const handleLimpar = () => {
		handleCadastroClear(cadastro);
		cadastro.idConsulta = idConsulta!;
	};

	const handleFinalizar = () => {
		envio();
	};

	const handleCardClick = (cardType: any) => {
		const sendTo = redirectMap[cardType];
		if (sendTo) navigate(sendTo);
	};

	const envio = async () => {
		try {
			setIsLoading(true);
			if (!cadastro.editarCadastro) {
				const corpo = {
					cpf: cadastro.cpf,
					nome: cadastro.nome,
					sexo: cadastro.sexo,
					data_nascimento: cadastro.data_nascimento,
					email: cadastro.email,
					telefone: cadastro.telefone,
					idConsulta: cadastro.idConsulta,
					password: cadastro.password,
					isEmpresa: cadastro.isEmpresa,
					dbName: dbName,
				};
				const response = await api.post("/criar-usuario", corpo);
				console.log("🚀 ~ envio ~ response:", response.data.id);
				if (response.status === 201) {
					setUserId(response.data.id);
					handleCadastroChange(cadastro);
					setIsLoading(false);
					setAlert({
						show: true,
						message: "Usuário criado com sucesso!",
						variant: "success",
					});
					if (
						location.pathname === `/aso/registro/validar-info-aso/${dbName}`
					) {
						return navigate(
							`/aso/registro/aviso-reconhecimento-facial-aso/${dbName}/${response.data.id}`,
						);
					} else {
						return navigate(
							`/aso/registro/aviso-reconhecimento-facial/${dbName}/${response.data.id}`,
						);
					}
				}
			} else {
				return navigate(
					`/aso/registro/reconhecimento-facial/${cadastro.idConsulta}/${dbName}`,
				);
			}
		} catch (error: any) {
			setIsLoading(false);
			setAlert({
				show: true,
				message: "Erro ao criar usuário!",
				variant: "danger",
			});
		}
	};

	const cardItem = ({
		className,
		icon,
		title,
		subTitle,
		btnText,
		cardActive,
		redirect,
		onCardClick,
	}: any) => (
		<Card
			className={`mb-1 card-item ${className} ${cardActive === "condition1" ? "card-active" : ""}`}
			style={{ height: "91px" }}
		>
			<Card.Body className="d-flex align-items-center justify-content-between card-body-mob-padding">
				{icon === "email" && (
					<div className={`${!cadastro.email ? "icon-mp" : "icon-mp-valid"}`}>
						<EmailMP />
					</div>
				)}
				{icon === "id" && (
					<div
						className={`${!cadastro.versoDocumento ? "icon-mp" : "icon-mp-valid"}`}
					>
						<IdMP />
					</div>
				)}
				{icon === "phone" && (
					<div
						className={`${!cadastro.telefone ? "icon-mp" : "icon-mp-valid"}`}
					>
						<PhoneMP />
					</div>
				)}
				{icon === "password" && (
					<div
						className={`${!cadastro.password ? "icon-mp" : "icon-mp-valid"}`}
					>
						<PasswordMP />
					</div>
				)}
				<div className="valid-card-group" style={{ flex: 1 }}>
					<Card.Text className="card-text-title-normal-size card-text-title-mob-size">
						{title}
					</Card.Text>
					<Card.Text className="text-muted card-text-subtitle-normal-size card-text-subtitle-mob-size">
						{subTitle}
					</Card.Text>
				</div>
				{cardActive === "condition1" ? (
					<Button
						variant="primary"
						className="aso-btn-mp"
						onClick={() => navigate(redirectMap[redirect])}
					>
						{btnText}
					</Button>
				) : cardActive === "condition2" ? (
					<div className="andes-list__item-second-column">
						<div className="andes-list__item-tertiary-container andes-list__item-tertiary-container--top">
							<span className="andes-list__item-tertiary andes-list__item-tertiary--top">
								<button
									type="button"
									className="andes-button hub-item__button-edit andes-button--medium andes-button--transparent button-editar-mob-size"
									aria-label="Editar"
									onClick={onCardClick}
								>
									<span className="andes-button__content span-editar-mob-size">
										<svg
											aria-hidden="true"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="rgba(0, 0, 0, 0.9)"
										>
											<path
												fillRule="evenodd"
												clipRule="evenodd"
												d="M21.807 6.96258L16.9706 2L2 17.0575V21.8211H6.76999L21.807 6.96258ZM16.96 4.13811L19.693 6.94211L18.1783 8.43877L15.4232 5.68368L16.96 4.13811ZM14.3656 6.74736L3.5 17.6751V20.3201H6.154L17.1113 9.49309L14.3656 6.74736Z"
												fill="rgba(0, 0, 0, 0.9)"
											></path>
										</svg>
									</span>
								</button>
							</span>
						</div>
					</div>
				) : null}
			</Card.Body>
		</Card>
	);

	return (
		<>
			<Load isLoading={isLoading} />
			{!isLoading && (
				<div className="background background-vi-desktop background-mobile">
					<div className="container" style={{ maxWidth: "500px" }}>
						<Card style={{ width: "100%" }}>
							<Card.Body className="card-body-vi-desktop card-body-mobile">
								<Card.Title
									style={{
										textAlign: "center",
										padding: "10px",
										fontSize: "22px",
										fontWeight: "600",
										marginBottom: "0",
									}}
								>
									{" "}
									Validação de Informações{" "}
								</Card.Title>
								<Card.Text
									style={{
										textAlign: "center",
										padding: "10px",
										fontSize: "14px",
									}}
								>
									{" "}
									Valide as informações necessárias para finalizar o cadastro{" "}
								</Card.Text>
								<div className="mt-3">
									{cardItem({
										className: !cadastro.email ? "card-add" : "card-valid",
										icon: "email",
										title: "Validação de email",
										subTitle: cadastro.email || "Adicione seu e-mail",
										btnText: "Validar",
										cardActive: !cadastro.email
											? "condition1"
											: cadastro.emailValidado
												? "condition2"
												: null,
										redirect: "email",
										onCardClick: () => handleCardClick("email"),
									})}
									{cardItem({
										className: !cadastro.versoDocumento
											? "card-add"
											: "card-valid",
										icon: "id",
										title: "Validação de identidade",
										subTitle: cadastro.versoDocumento
											? "Identidade validada"
											: "Adicione sua identidade",
										btnText: "Validar",
										cardActive:
											cadastro.emailValidado &&
											!cadastro.cpfValidado &&
											!cadastro.versoDocumento
												? "condition1"
												: cadastro.frenteDocumentoValidado &&
														cadastro.versoDocumentoValidado
													? "condition2"
													: "",
										redirect: "id",
										onCardClick: () => handleCardClick("id"),
									})}
									{cardItem({
										className: !cadastro.telefone ? "card-add" : "card-valid",
										icon: "phone",
										title: "Validação de telefone",
										subTitle: cadastro.telefone || "Adicione seu telefone",
										btnText: "Validar",
										cardActive:
											cadastro.emailValidado &&
											cadastro.cpfValidado &&
											cadastro.versoDocumento &&
											!cadastro.telefone
												? "condition1"
												: cadastro.telefoneValidado
													? "condition2"
													: "",
										redirect: "telefone",
										onCardClick: () => handleCardClick("telefone"),
									})}
									{cardItem({
										className: !cadastro.password ? "card-add" : "card-valid",
										icon: "password",
										title: "Validação de senha",
										subTitle: cadastro.password
											? "Senha criada com sucesso"
											: "Crie sua senha",
										btnText: "Validar",
										cardActive:
											cadastro.emailValidado &&
											cadastro.cpfValidado &&
											cadastro.versoDocumento &&
											cadastro.telefone &&
											!cadastro.password
												? "condition1"
												: cadastro.passwordValidada
													? "condition2"
													: "",
										redirect: "password",
										onCardClick: () => handleCardClick("password"),
									})}
								</div>
								<div className="aso-botoes-finalizar-cad">
									<Button
										variant="primary"
										className="aso-btn-mp"
										onClick={handleLimpar}
									>
										Limpar
									</Button>
									<Button
										variant="primary"
										className="aso-btn-mp"
										onClick={handleFinalizar}
										disabled={isDisabled}
									>
										{!cadastro.editarCadastro ? "Finalizar" : "Continuar"}
									</Button>
								</div>
							</Card.Body>
						</Card>
					</div>
				</div>
			)}
			<AlertMessage
				show={alert.show}
				message={alert.message}
				variant={alert.variant}
				onClose={() => setAlert({ ...alert, show: false })}
			/>
		</>
	);
};

export default AsoValidarInfo;
